/** @prettier */
import React from 'react';
import { useDispatch } from 'react-redux';
import MultiCamIcon from '@surfline/quiver-react/dist/MultiCamIcon';
import Button from '@surfline/quiver-react/dist/Button';
import { canUseDOM } from '@surfline/web-common/dist';
import en from '../../intl/translations/en';
import { clickedCreateAccountCTA } from '../../actions/segmentEvents';
import { assignLocation } from '../../utils/assignLocation';

const MultiCamRegWall = () => {
  const dispatch = useDispatch();

  const copy = en.MultiCam.regwall;
  const redirectUrl = canUseDOM ? encodeURIComponent(window.location) : '';
  return (
    <div className="sl-multi-cam-regwall">
      <div className="sl-multi-cam-regwall__outer-circle">
        <div className="sl-multi-cam-regwall__inner-circle">
          <MultiCamIcon />
        </div>
      </div>
      <h1 className="sl-multi-cam-regwall__header">{copy.header}</h1>
      <Button
        onClick={() => {
          dispatch(
            clickedCreateAccountCTA({
              category: 'cams & reports',
              pageName: 'multi-cam',
            })
          );
          assignLocation('/create-account');
        }}
      >
        {copy.createAccount}
      </Button>
      <span className="sl-multi-cam-regwall__disclaimer">{copy.disclaimer}</span>
      <span className="sl-multi-cam-regwall__link-container">
        {copy.preLinkCopy}{' '}
        <a className="sl-multi-cam-regwall__link" href={`/sign-in?redirectUrl=${redirectUrl}`}>
          {copy.link}
        </a>
      </span>
    </div>
  );
};

MultiCamRegWall.propTypes = {};

export default MultiCamRegWall;
